// tl.js — Filipino (Tagalog) translation for flatpickr
export const Filipino = {
    weekdays: {
      shorthand: ['Lin', 'Lun', 'Mar', 'Miy', 'Huw', 'Biy', 'Sab'],
      longhand: [
        'Linggo',
        'Lunes',
        'Martes',
        'Miyerkules',
        'Huwebes',
        'Biyernes',
        'Sabado',
      ],
    },
    months: {
      shorthand: [
        'Ene', 'Peb', 'Mar', 'Abr', 'May', 'Hun',
        'Hul', 'Ago', 'Set', 'Okt', 'Nob', 'Dis'
      ],
      longhand: [
        'Enero',
        'Pebrero',
        'Marso',
        'Abril',
        'Mayo',
        'Hunyo',
        'Hulyo',
        'Agosto',
        'Setyembre',
        'Oktubre',
        'Nobyembre',
        'Disyembre',
      ],
    },
    firstDayOfWeek: 1,
  };
  